import React from 'react'
import { Link } from 'react-router-dom'

import config from '../../config/config'
import { POI_PATH, EVENT_PATH } from '../../config/routes'
import { getPoiLabel, getPoiTypeLabelFromPoi, slugify } from '../../utils/utils'
import { useLanguage } from '../../contexts/LanguageContext'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../utils/dateUtils'

const PoiThumbnail = ({ poi, isCategory = true, isCity = true }) => {
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()

  const poiLabel = getPoiLabel(poi, activeLanguage)
  const poiTypeLabel = getPoiTypeLabelFromPoi(poi, activeLanguage)

  const defaultIndex =
    Math.floor(Math.random() * config.defaultThumbnailsCount) + 1
  const defaultImgSrc = `${config.thumbnailsPath}DEFAULT_THUMBNAIL_${defaultIndex}.jpg`

  const imgSrc =
    poi.mainPhotoId !== 0
      ? `${config.photoUrlMedium}${poi.mainPhotoId}.jpg`
      : defaultImgSrc

  const linkPath = poi.isEvent ? EVENT_PATH : POI_PATH

  return (
    <Link
      to={`${linkPath
        .replace(':slug', slugify(poiLabel))
        .replace(':id', poi.id)}`}
      className="card-hover"
    >
      <img src={imgSrc} alt={poiLabel} className="card-img-top" />
      <div className="card-body">
        <h3 className="card-title">
          {poiLabel} {poi.status === 'DRAFT' ? ' - Fiche non publiée' : ''}
        </h3>
        <p className="card-text">
          {isCategory && (
            <>
              {t('CATEGORY')}: {poiTypeLabel}
              <br />
            </>
          )}
          {isCity && poi.city && poi.city.label && (
            <>
              {t('POI_VILLAGE_LABEL')}: {poi.city.label}
              <br />
            </>
          )}
          {poi.isEvent &&
            poi.startDate &&
            !poi.endDate &&
            `${formatDate(poi.startDate, true)}`}
          {poi.isEvent &&
            poi.startDate &&
            poi.endDate &&
            `${formatDate(poi.startDate, true)} -> ${formatDate(
              poi.endDate,
              true,
            )}`}
        </p>
      </div>
    </Link>
  )
}

export default PoiThumbnail
